<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>结算中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'accountFinance' }">账户资金</el-breadcrumb-item>
        <el-breadcrumb-item>提现明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="申请日期：" prop="timeInterval">
              <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="订单号：" prop="orderNum">
              <el-input size="small" v-model="listParams.orderNum" placeholder="请输入订单号"> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="提现状态：" prop="status">
              <el-select style="width: 100%" size="small" placeholder="请选择提现状态" v-model="listParams.status">
                <el-option value="" label="全部"></el-option>
                <el-option value="01" label="待审核"></el-option>
                <el-option value="02" label="已打款"></el-option>
                <el-option value="03" label="已完成"></el-option>
                <el-option value="04" label="提现失败"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
              <el-button size="small" @click="resetForm('listForm')"> 重置 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <span>提现明细：</span>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column width="60" align="center" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="申请时间" prop="applyDate"> </el-table-column>

        <el-table-column align="center" label="提现订单号" prop="orderNum"> </el-table-column>

        <el-table-column align="center" label="提现银行卡" prop="bankCard">
          <template slot-scope="scope">
            {{ scope.row.bankCard | formatBankcard }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="所属银行" prop="belongedBank"> </el-table-column>

        <el-table-column align="center" label="联系人" prop="connecter"> </el-table-column>

        <el-table-column align="center" label="提现金额(元)" prop="settlementAmount"> </el-table-column>

        <el-table-column align="center" label="手续费(元)" prop="serviceCharge"> </el-table-column>

        <el-table-column align="center" label="实际到账(元)" prop="actualAccount"> </el-table-column>

        <el-table-column align="center" label="提现状态" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status === '1'" style="color: rgba(128, 128, 128, 0.78)">待审核</span>
            <span v-if="scope.row.status === '2'" style="color: rgba(0, 128, 0, 0.76)">已打款</span>
            <span v-if="scope.row.status === '3'" style="color: #000">已完成</span>
            <span v-if="scope.row.status === '4'" style="color: rgba(255, 0, 0, 0.69)">
              提现失败
              <el-tooltip class="item" effect="dark" :content="scope.row.failReason" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        timeInterval: ["", ""],
        orderNum: "",
        status: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      });
      bodyParams.startDate = bodyParams.timeInterval[0];
      bodyParams.endDate = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      this.$http({
        url: global.apiUrl + "/settlement/withdrawDetailList",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
